import { render, staticRenderFns } from "./files-icon.vue?vue&type=template&id=73fdec71&scoped=true&lang=pug&"
import script from "./files-icon.vue?vue&type=script&lang=js&"
export * from "./files-icon.vue?vue&type=script&lang=js&"
import style0 from "./files-icon.vue?vue&type=style&index=0&id=73fdec71&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdec71",
  null
  
)

export default component.exports